import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { API_URL } from '../config/api';
import SEO from '../components/SEO';
import './Information.css';
import './Gdpr.css';

const GeneralTerms = () => {
  const { t, i18n } = useTranslation();
  const [contentFi, setContentFi] = useState('');
  const [contentEn, setContentEn] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await axios.get(`${API_URL}/settings/general-terms`);
        setContentFi(response.data.generalTerms || '');
        setContentEn(response.data.generalTermsEn || '');
      } catch (err) {
        console.error('Error fetching general terms:', err);
        setError(t('generalTerms.loadError') || 'Could not load content.');
      } finally {
        setLoading(false);
      }
    };
    fetchTerms();
  }, [t]);

  const isEn = (i18n.language || '').toLowerCase().startsWith('en');
  const content = isEn ? (contentEn || contentFi) : (contentFi || contentEn);

  const blocks = (content || '')
    .split(/\n\n+/)
    .map((block) => block.trim())
    .filter(Boolean);

  if (loading) {
    return (
      <div className="information-container gdpr-page">
        <div className="container">
          <p>{t('admin.loading') || 'Loading...'}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="information-container gdpr-page">
        <div className="container">
          <p className="error-message">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="information-container gdpr-page">
      <SEO title={t('generalTerms.title') || 'Yleiset ehdot'} description="Käyttöehdot ja yleiset palveluehdot." path="/general-terms" />
      <div className="container">
        <h1 className="gdpr-title">{t('generalTerms.title') || 'Yleiset ehdot'}</h1>
        <div className="information-content gdpr-content">
          <div className="gdpr-body">
            {blocks.length === 0 ? (
              <p className="gdpr-paragraph">{t('generalTerms.empty') || 'Yleisiä ehtoja ei ole vielä julkaistu.'}</p>
            ) : (
              blocks.map((block, i) => {
                if (block.startsWith('## ')) {
                  return (
                    <h2 key={i} className="gdpr-section-title">
                      {block.slice(3).trim()}
                    </h2>
                  );
                }
                return (
                  <p key={i} className="gdpr-paragraph">
                    {block}
                  </p>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralTerms;
